import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";
import { Spin, message } from "antd";

function Team() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/team");
      setTeamMembers(response.data);
    } catch (error) {
      message.error("Failed to fetch team members.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section style={styles.teamSection}>
        <HeroPages name="Meet Our Team" />
        <div style={styles.container}>
          <h2 style={styles.heading}>Our Dedicated Professionals</h2>

          {/* Loading Indicator */}
          {loading ? (
            <div style={styles.loaderContainer}>
              <Spin size="large" />
            </div>
          ) : (
            <div style={styles.teamGrid}>
              {teamMembers.length > 0 ? (
                teamMembers.map((member) => (
                  <div key={member.id} style={styles.teamCard}>
                    <div style={styles.teamCardImage}>
                      <img
                        src={`http://93.127.203.113:5005${member.image}`} // Dynamically load images from API
                        alt={member.name}
                        style={styles.image}
                      />
                    </div>
                    <div style={styles.teamCardContent}>
                      <h3 style={styles.name}>{member.name}</h3>
                      <p style={styles.job}>{member.job}</p>
                      <div style={styles.socialIcons}>
                        <FaLinkedin style={styles.icon} />
                        <FaTwitter style={styles.icon} />
                        <FaInstagram style={styles.icon} />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p style={styles.noDataText}>No team members found.</p>
              )}
            </div>
          )}
        </div>

        {/* Contact Banner */}
        <div style={styles.bookBanner}>
          <div style={styles.bookBannerOverlay}></div>
          <div style={styles.container}>
            <div style={styles.bookBannerContent}>
              <h2>Book a car by getting in touch with us</h2>
              <span style={styles.bookBannerContact}>
                <i className="fa-solid fa-phone"></i>
                <h3>(2519) 456-7869</h3>
              </span>
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

/* 🎨 Styled Components */
const styles = {
  teamSection: {
    padding: "60px 0",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
  },
  container: {
    width: "90%",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#0c8c49",
    marginBottom: "30px",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "150px",
  },
  teamGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "30px",
    marginTop: "20px",
  },
  teamCard: {
    background: "white",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
    textAlign: "center",
    padding: "20px",
    position: "relative",
  },
  teamCardImage: {
    width: "180px",
    height: "180px",
    margin: "0 auto",
    borderRadius: "50%",
    overflow: "hidden",
    border: "5px solid #0c8c49",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  teamCardContent: {
    marginTop: "15px",
  },
  name: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#333",
  },
  job: {
    fontSize: "16px",
    color: "#666",
    fontWeight: "500",
    marginBottom: "10px",
  },
  socialIcons: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    marginTop: "10px",
  },
  icon: {
    fontSize: "20px",
    color: "#0c8c49",
    cursor: "pointer",
    transition: "color 0.3s ease",
  },
  noDataText: {
    fontSize: "18px",
    color: "#666",
    textAlign: "center",
    marginTop: "20px",
  },
  bookBanner: {
    marginTop: "50px",
    padding: "50px 0",
    background: "#0c8c49",
    color: "white",
    textAlign: "center",
    position: "relative",
  },
  bookBannerOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.3)",
  },
  bookBannerContent: {
    position: "relative",
    zIndex: "2",
  },
  bookBannerContact: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    fontSize: "20px",
    fontWeight: "bold",
  },
};

/* 📱 Responsive Design */
styles.teamGrid["@media (max-width: 1024px)"] = {
  gridTemplateColumns: "repeat(2, 1fr)",
};
styles.teamGrid["@media (max-width: 768px)"] = {
  gridTemplateColumns: "repeat(1, 1fr)",
};

/* ✨ Hover Effect */
styles.teamCard[":hover"] = {
  transform: "scale(1.05)",
  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
};

export default Team;
